<div class="cb-checkbox-container" [class.disabled]="disabled" [class.align-center]="alignCenter" [class.error]="error"
  (click)="toggleCheckbox()">
  <div class="cb-checkbox">
    <div class="cb-checkbox-box" [class.selected]="value">
      <ion-icon name="checkmark"></ion-icon>
    </div>
  </div>
  <ng-content></ng-content>
</div>